module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_L5-b59f701586d07d32a8f9872f4c663693.png";